export default __webpack_public_path__ + "static/media/file-web_lightGray3.aa8d3386.svg";